import { useEffect, useState } from 'react';
import '~/apps/App.css';
import '~/apps/common.css';
import {useSearchBox} from 'react-instantsearch';
import Form from "~/components/Form.js";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from '@mui/icons-material/Clear';
import queryStrReader from '~/helpers/queryStrReader.js';
import {useLocation, useNavigate} from "react-router-dom";

function SearchBox({autoFocus, delay, translations, ...props}) {
    const location = useLocation();
    const navigate = useNavigate();
    const {refine, query} = useSearchBox({autoFocus, translations});

    const [currentRefinement, setCurrentRefinement] = useState(query);

    const [value, setValue] = useState('');
    const [timerId, setTimerId] = useState(null);
    const [timerStarted, setTimerStarted] = useState(false);

    const handleReset = e => {
        e.stopPropagation();
        refine('');
        setCurrentRefinement('');
        navigate(location.pathname);
    };

    const updateRefinement = value => {
        refine(value);
        setCurrentRefinement(value);
        if (value === '') {
            navigate(location.pathname);
        }
        setTimerStarted(false);
    };

    const onChangeDebounced = e => {
        const value = e.currentTarget.value;
        clearTimeout(timerId);
        setTimerStarted(true);
        setTimerId(setTimeout(() => updateRefinement(value), delay));
        setValue(value);
    };

    useEffect(() => {
        if (!timerStarted) {
            if (currentRefinement !== value) {
                setValue(currentRefinement)
            }
            if (value === currentRefinement &&
                query !== value &&
                (queryStrReader(location.search).query ?? '') === query
            ) {
                setValue(query);
                setCurrentRefinement(query);
            }
        }
    });

    const resetButton = {};

    if (value && value.trim().length > 0) {
        resetButton.endAdornment = <InputAdornment position="end">
            <IconButton aria-label="Reset" onClick={handleReset} size="large">
                <ClearIcon/>
            </IconButton>
        </InputAdornment>;
    }

    return <Form noValidate action="" role="search" name="search">
        <TextField
            type="search"
            label="Search Name, Title, Phone, Department..."
            name="peopleSearch"
            id="peopleSearch"
            className="directorysearch-text-field"
            value={value}
            onChange={onChangeDebounced}
            margin="normal"
            variant="outlined"
            slotProps={{
                inputLabel: {className: "text-field-label"},
                input: Object.assign({
                    endAdornment: <InputAdornment position="start">
                        <IconButton aria-label="Search" onClick={() => {return null}} size="large">
                            <SearchIcon/>
                        </IconButton>
                    </InputAdornment>
                }, resetButton),
                htmlInput: {className: "text-field-input"}
            }}
        />
    </Form>;
}

export default SearchBox;